import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Facebook } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { cn } from '../../lib/utils';
export function Footer() {
  const currentYear = new Date().getFullYear();
  const {
    t,
    isRTL
  } = useLanguage();
  return <footer className="bg-gray-900 text-gray-300" data-id="element-22">
      <div className="container mx-auto px-4 md:px-6 py-12 md:py-16" data-id="element-23">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12" data-id="element-24">
          {/* Brand Info */}
          <div className="space-y-4" data-id="element-25">
            <div className="flex items-center gap-3" data-id="element-26">
              <img src="https://cdn.magicpatterns.com/uploads/stkewdFoDLsveAsLMC6296/favi__logo.png" alt="KMA UK Logo" className="h-12 w-12 object-contain" data-id="element-27" />
              <span className="text-xl font-serif font-bold text-white" data-id="element-28">
                KMA UK
              </span>
            </div>
            <p className="text-sm leading-relaxed text-gray-400" data-id="element-29">
              {t('footer.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-30">
            <h3 className="text-white font-serif font-semibold mb-4" data-id="element-31">
              {t('footer.quickLinks')}
            </h3>
            <ul className="space-y-2 text-sm" data-id="element-32">
              <li data-id="element-33">
                <Link to="/about" className="hover:text-primary-400 transition-colors" data-id="element-34">
                  {t('nav.about')}
                </Link>
              </li>
              <li data-id="element-35">
                <Link to="/membership" className="hover:text-primary-400 transition-colors" data-id="element-36">
                  {t('nav.membership')}
                </Link>
              </li>
              <li data-id="element-37">
                <Link to="/events" className="hover:text-primary-400 transition-colors" data-id="element-38">
                  {t('nav.events')}
                </Link>
              </li>
              <li data-id="element-39">
                <Link to="/charity" className="hover:text-primary-400 transition-colors" data-id="element-40">
                  {t('nav.charity')}
                </Link>
              </li>
              <li data-id="element-41">
                <Link to="/team" className="hover:text-primary-400 transition-colors" data-id="element-42">
                  {t('nav.team')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-43">
            <h3 className="text-white font-serif font-semibold mb-4" data-id="element-44">
              {t('footer.contactUs')}
            </h3>
            <ul className="space-y-3 text-sm" data-id="element-45">
              <li className="flex items-start space-x-3" data-id="element-46">
                <MapPin className={cn('h-5 w-5 text-primary-500 shrink-0', isRTL && 'ml-3')} data-id="element-47" />
                <span data-id="element-48">
                  17 Honeybourne,
                  <br data-id="element-49" />
                  Bishop's Stortford, CM23 4EF
                </span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-50">
                <Mail className={cn('h-5 w-5 text-primary-500 shrink-0', isRTL && 'ml-3')} data-id="element-51" />
                <a href="mailto:info@kmauk.org" className="hover:text-primary-400" data-id="element-52">
                  info@kmauk.org
                </a>
              </li>
            </ul>
          </div>

          {/* Legal & Social */}
          <div data-id="element-53">
            <h3 className="text-white font-serif font-semibold mb-4" data-id="element-54">
              {t('footer.connect')}
            </h3>
            <div className="flex space-x-4 mb-6" data-id="element-55">
              <a href="#" className="p-2 bg-gray-800 rounded-full hover:bg-primary-600 transition-colors" aria-label="Facebook" data-id="element-56">
                <Facebook className="h-4 w-4" data-id="element-57" />
              </a>
            </div>
            <div className="text-sm space-y-2" data-id="element-58">
              <Link to="/privacy" className="block hover:text-primary-400" data-id="element-59">
                {t('footer.privacyPolicy')}
              </Link>
              <Link to="/privacy" className="block hover:text-primary-400" data-id="element-60">
                {t('footer.termsOfService')}
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-sm text-gray-500" data-id="element-61">
          <p data-id="element-62">
            {t('footer.copyright').replace('{year}', currentYear.toString())}
          </p>
          <p className="mt-2 text-xs" data-id="element-63">{t('footer.charity')}</p>
        </div>
      </div>
    </footer>;
}